export default ({ request }) => ({

  listResearchInfoApi(data) {
    return request({
      url: '/digitalCenter/researchInfo/list',
      method: 'post',
      data
    })
  },
  saveResearchInfoApi(data) {
    return request({
      url: '/digitalCenter/researchInfo/save',
      method: 'post',
      data
    })
  },
  detailResearchInfoApi(data) {
    return request({
      url: '/digitalCenter/researchInfo/detail',
      method: 'post',
      data
    })
  },
  delResearchInfoApi(data) {
    return request({
      url: '/digitalCenter/researchInfo/del',
      method: 'post',
      data
    })
  },
  imageListResearchInfoApi(data) {
    return request({
      url: '/digitalCenter/researchInfoImage/list',
      method: 'post',
      data
    })
  }
})
